import { Directive, ElementRef, HostBinding, inject, input, OnDestroy, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { filter, map, Subject, take, takeUntil } from 'rxjs';
import { InViewService } from '../../services/in-view.service';

@Directive({
  selector: '[animateInView]',
  standalone: true,
  host: {
    '[class.animation-up]': 'animateInView() === "up" && !isStoryblok()',
    '[class.animation-scale]': 'animateInView() === "scale" && !isStoryblok()',
    '[class.animation-fade]': 'animateInView() === "fade" && !isStoryblok()',
    '[class.animation-left]': 'animateInView() === "left" && !isStoryblok()',
    '[class.animation-right]': 'animateInView() === "right" && !isStoryblok()',
    '[class.animated]': 'inView()',
    '[style.animation-delay.ms]': 'minDelay() ? minDelay() + "ms" : "0"',
  },
})
export class AnimateWhenInViewDirective implements OnInit, OnDestroy {
  private el = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  private inViewService = inject(InViewService);
  private route = inject(ActivatedRoute);
  @HostBinding('class') elementClass: string;
  readonly animateInView = input<'up' | 'scale' | 'fade' | 'left' | 'right'>(undefined);
  readonly minDelay = input<number>(undefined);
  readonly delay = input<number>(undefined);
  readonly isStoryblok = toSignal(this.route.queryParams.pipe(map(params => !!params._storyblok)));
  readonly inView = signal(false);
  destroyed$ = new Subject<void>();

  ngOnInit() {
    const rootMargin = this.animateInView() === 'up' ? '0px 0px -50px 0px' : '0px 0px -50px 0px';
    this.inViewService
      .observe(this.el, rootMargin)
      .pipe(filter(Boolean), take(1), takeUntil(this.destroyed$))
      .subscribe(() => {
        this.inView.set(true);
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
